import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/call-answer.png'
import _imports_1 from '@/assets/img/001-envelope.png'
import _imports_2 from '@/assets/img/translate.svg'
import _imports_3 from '../assets/img/logo_1.png'


const _withScopeId = n => (_pushScopeId("data-v-24a248c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upper-bar text-center" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-4 col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "mr-custom",
      href: "tel:516551615616"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "m-1",
        src: _imports_0,
        alt: ""
      }),
      /*#__PURE__*/_createTextVNode(" 0055050505 ")
    ]),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:pitpoint@gmail.com" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "m-1",
        src: _imports_1,
        alt: ""
      }),
      /*#__PURE__*/_createTextVNode(" pitpoint@gmail.com ")
    ])
  ])
], -1))
const _hoisted_5 = { class: "col-lg-6 col-md-8 col-sm-12" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "who-we" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "dropdown m-1" }
const _hoisted_10 = {
  class: "btn btn-flag dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton1",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "mx-2" }
const _hoisted_15 = { class: "flag border" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "dropdown avatar-wrapper ml-custom"
}
const _hoisted_18 = {
  class: "btn dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "user_name mx-1" }
const _hoisted_21 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Back", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-left" }, null, -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "dropdown-header text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "English", -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-info fa-sm ml-1" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "العربية", -1))
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-info fa-sm ml-1" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "items"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "nav_icon",
  alt: ""
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1))
const _hoisted_40 = {
  key: 1,
  class: "ml-custom mr-custom"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-in-alt mx-2" }, null, -1))
const _hoisted_42 = {
  class: "navbar navbar-expand-lg navbar-light",
  style: {"background-color":"#0E5AA6"}
}
const _hoisted_43 = { class: "container-fluid" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-custom",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_46 = {
  class: "collapse navbar-collapse",
  id: "navbarNav"
}
const _hoisted_47 = { class: "navbar-nav" }
const _hoisted_48 = { class: "navbar-nav nav-end navbar-right nav-icons" }
const _hoisted_49 = { class: "nav-item mx-2" }
const _hoisted_50 = { class: "fav-num badge-box" }
const _hoisted_51 = { class: "badge rounded-circle badge-danger" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-heart" }, null, -1))
const _hoisted_53 = { class: "nav-item ml-custom" }
const _hoisted_54 = { class: "cart-num badge-box" }
const _hoisted_55 = { class: "badge rounded-circle badge-danger" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M.263,6.819a1.172,1.172,0,0,1,.909-.433H22.4l.087-.8,0-.026A6.412,6.412,0,0,1,28.828,0a1.172,1.172,0,0,1,0,2.344,4.062,4.062,0,0,0-4.014,3.511l-1.393,12.8a3.521,3.521,0,0,1,2.067,3.2c0,.01,0,.02,0,.029s0,.02,0,.029a3.52,3.52,0,0,1-3.516,3.516H21.5a3.457\n                                                ,3.457,0,1,1-6.546,0H9.894a3.457,3.457,0,1,1-3.273-2.344H21.973a1.173,1.173,0,0,0,1.172-1.172c0-.01,0-.02,0-.029s0-.02,0-.029a1.173,1.173,0,0,0-1.172-1.172H7.012A5.366,5.366,0,0,1,2.148,17.4a1.172,1.172,0,0,1,2.146-.942A3.064,3.064,0,0,0,7.012,18.34H21.1L22.143,\n                                                8.73H2.613l.573,2.749a1.172,1.172,0,1,1-2.294.479L.025,7.8A1.172,1.172,0,0,1,.263,6.819ZM6.621,25.43a1.113,1.113,0,1,0,1.113,1.113A1.115,1.115,0,0,0,6.621,25.43Zm11.6,0a1.113,1.113,0,1,0,1.113,1.113A1.115,1.115,0,0,0,18.223,25.43Z",
    transform: "translate(0)",
    fill: "#fff"
  })
], -1))
const _hoisted_57 = { class: "position-relative" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "position-absolute total-cart" }, " 0.00$", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  class: "ml-4",
                  to: "/about"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('nav.about')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/privacy-policy" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('nav.privacy-policy')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", _hoisted_10, [
                    _createElementVNode("img", {
                      src: _ctx.currency.flag,
                      class: "flag",
                      alt: ""
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                      return (_openBlock(), _createElementBlock("button", {
                        type: "button",
                        class: _normalizeClass(["dropdown-item", {'current' : country.id === _ctx.currency.id}]),
                        onClick: ($event: any) => ($options.handleChangeCountry(country)),
                        key: country.id
                      }, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(country.name), 1),
                        _createElementVNode("span", _hoisted_15, [
                          _createElementVNode("img", {
                            src: country.flag,
                            class: "flag",
                            alt: ""
                          }, null, 8, _hoisted_16)
                        ])
                      ], 10, _hoisted_13))
                    }), 128))
                  ])
                ]),
                (_ctx.user.loggedIn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("button", _hoisted_18, [
                        _createElementVNode("img", {
                          src: _ctx.user.data && _ctx.user.data.image? _ctx.user.data.image : require('@/assets/img/no-avatar.png'),
                          class: _normalizeClass({'no-avatar': _ctx.user.data ? !_ctx.user.data.image : ''}),
                          alt: ""
                        }, null, 10, _hoisted_19),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.user.data ? _ctx.user.data.name : ''), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        ($data.switcher)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("a", {
                                href: "#",
                                class: "dropdown-item back-arrow text-left",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($options.toggleDropDown && $options.toggleDropDown(...args)), ["prevent"]))
                              }, _hoisted_25),
                              _createElementVNode("h6", _hoisted_26, _toDisplayString(_ctx.$t('nav.change-language')), 1),
                              _hoisted_27,
                              _createElementVNode("a", {
                                class: "dropdown-item lang",
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.switchLang('en')))
                              }, [
                                _hoisted_28,
                                (_ctx.$i18n.locale === 'en')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_31))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("a", {
                                class: "dropdown-item lang",
                                href: "#",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.switchLang('ar')))
                              }, [
                                _hoisted_32,
                                (_ctx.$i18n.locale === 'ar')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _hoisted_35))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createVNode(_component_router_link, {
                                class: "dropdown-item",
                                to: "/settings"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_37,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.settings')), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("a", {
                                href: "#",
                                class: "dropdown-item",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($options.toggleDropDown && $options.toggleDropDown(...args)), ["prevent"]))
                              }, [
                                _hoisted_38,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.change-language')), 1)
                              ]),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                href: "#",
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.handleLogout && $options.handleLogout(...args)))
                              }, [
                                _hoisted_39,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.logout')), 1)
                              ])
                            ]))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-brand",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (this.$router.push('/login')))
                      }, [
                        _hoisted_41,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Login')), 1)
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createVNode(_component_router_link, {
          class: "navbar-brand mr-lg-0",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_44
          ]),
          _: 1
        }),
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("ul", _hoisted_47, [
            _createElementVNode("li", {
              class: _normalizeClass(["nav-item", {'currentPage' : _ctx.$route.name === 'Brands'}])
            }, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/brands"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('nav.all-brands')), 1)
                ]),
                _: 1
              })
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Categories, (category) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["nav-item", {'currentPage' : _ctx.$route.name === 'Brand' && _ctx.$route.params.id === category.id}]),
                key: category.id
              }, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: {name:'Brand',params:{id:category.id}}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(category.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("ul", _hoisted_48, [
            _createElementVNode("li", _hoisted_49, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/favourite"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_50, [
                    _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.favItemsCount > 0 ? _ctx.favItemsCount : ''), 1),
                    _hoisted_52
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('nav.favourite')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_53, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/cart"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_54, [
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.cartItemsCount > 0 ? _ctx.cartItemsCount : ''), 1),
                    _hoisted_56
                  ]),
                  _createElementVNode("span", _hoisted_57, [
                    _createTextVNode(_toDisplayString(_ctx.$t('nav.cart')) + " ", 1),
                    _hoisted_58,
                    _hoisted_59
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}